export default "__VITE_ASSET__B833sT3N__"